/**
 * Notifications collection. The url takes an array of objects so these are generally batch operations
 */
// import _ from 'underscore';
import v5_Collection   from '@/collections/v5/collection';
import Radio from 'backbone.radio';
import Api from '@/lib/api/api';
import Notification from '@/models/v5/notification';

var globalCh = Radio.channel('global');

const notifications_collection = v5_Collection.extend({
    url: function() {
        return Api.urls.notifications();
    },
    initialize: function () {
             globalCh.reply('wsCreateNotification', function(msg) {
                return msg;
            });
            this.sortVar = "created_at";
    },
    count: function() {
        return Notifications.filter(function(data){
            return data.attributes['read'] === false; 
        }).length;
    },
    model: Notification,
    comparator: function(a, b) {
        if (b.get(this.sortVar) > a.get(this.sortVar)) return 1;
        else return -1;
    },
    sortByField: function (fieldName) {
        this.sort_key = fieldName;
        this.sort();
    },
    create: function() {
        return Api.ajax_v5({
            method: 'POST',
            url: Api.urls.notifications(),
            
        });
    },
    list_one: function(notification_id) {
        return Api.ajax_v5({
            method: 'GET',
            url: Api.urls.notifications()/notification_id,
        });
    },
    list_all: function() {
        return Api.ajax_v5({
            method: 'GET',
            url: Api.urls.notifications(), 
        });
    },
    mark_read: function(notifications){
        if (Array.isArray(notifications) && notifications.length > 0) {
            var all_notifications = [];
            for (var i = 0; i < notifications.length; i++) {
                var obj = {
                    type: Notification.type,
                    id: notifications[i].get('id'),
                    attributes: {
                        read: true,
                    }
                };

                // Update the original model
                notifications[i].set({ read: true }, { silent: true });

                all_notifications.push(obj);
            }

            var data = JSON.stringify({
                data: all_notifications
            });

            var options = {
                headers: {
                    'Content-type': 'application/vnd.api+json'
                },
                url: this.url(),
                patch: true,
                data: data,
            };

            this.trigger('mark_read');

            return this.sync('patch', this, options);
        }
    },
    delete: function(notifications) {
        if (Array.isArray(notifications) && notifications.length > 0) {
            var all_notifications = [];

            for (var i = 0; i < notifications.length; i++) {
                var obj = {
                    type: Notification.type,
                    id: notifications[i].get('id'),
                };

                // Update original model
                this.remove(notifications[i]);

                all_notifications.push(obj);
            }

            var data = JSON.stringify({
                data: all_notifications
            });

            return Api.ajax({
                url: this.url(),
                headers: {
                    'Content-type': 'application/vnd.api+json'
                },
                method: 'DELETE',
                data: data,
            });
        }
    }
});
 
const Notifications = new notifications_collection;

export default Notifications;
